module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main serversupport"
  }, [_c('div', {
    staticClass: "banner"
  }), _vm._v(" "), _c('div', {
    staticClass: "mainContent"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "firstArea"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.scrollToAnchor($event, 'overView')
      }
    }
  }, [_vm._v("Overview")])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.scrollToAnchor($event, 'createNew')
      }
    }
  }, [_vm._v("Create New Team")])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.scrollToAnchor($event, 'inviteMember')
      }
    }
  }, [_vm._v("Invite Member")])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.scrollToAnchor($event, 'removeMember')
      }
    }
  }, [_vm._v("Remove Member")])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.scrollToAnchor($event, 'LeaveTeam')
      }
    }
  }, [_vm._v("Leave Team")])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.scrollToAnchor($event, 'TeamSettings')
      }
    }
  }, [_vm._v("Team Settings")])])]), _vm._v(" "), _c('div', {
    staticClass: "secondArea"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.scrollToAnchor($event, 'signUp')
      }
    }
  }, [_vm._v("Sign up")])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.scrollToAnchor($event, 'forgotPassword')
      }
    }
  }, [_vm._v("Forgot Password")])])])]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "aboutus",
    attrs: {
      "id": "overView"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Overview")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("Crait platform is a secured and effective platform which designed to help business to better building and managing the company structure. On this platform, every manager can easily create teams and groups and invite people to join. ")])]), _vm._v(" "), _c('div', {
    staticClass: "aboutus",
    attrs: {
      "id": "createNew"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Create New Team")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("An user could create a new team for free. Create team From 'My Team' under 'Mine' or 'Team Manage' on webpage. Change the team  and logo, invite team members to join, create sub-teams under team, set team administrators, set team property, etc.")])]), _vm._v(" "), _c('div', {
    staticClass: "aboutus",
    attrs: {
      "id": "inviteMember"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Add Member")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("You can add members into the team via several methods: "), _c('br'), _vm._v("\n                                1. Crait contacts "), _c('br'), _vm._v("\n                                2. Establish the profile for a new member, then send an invitation. The invitees need to activate their Crait accounts via emails. ")])]), _vm._v(" "), _c('div', {
    staticClass: "aboutus",
    attrs: {
      "id": "removeMember"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Remove Member")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("The team owner and administrators of the team are allowed to remove team members."), _c('br'), _vm._v("\n                                Only the team owner is authorized to add or remove administrators from the team. ")])]), _vm._v(" "), _c('div', {
    staticClass: "aboutus",
    attrs: {
      "id": "LeaveTeam"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Leave Team")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("Any member is able to review the team details from the contact list and withdraw from any of the teams. ")])]), _vm._v(" "), _c('div', {
    staticClass: "aboutus",
    attrs: {
      "id": "TeamSettings"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Team Settings")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("Change the basic information about teams, including logo, , etc. "), _c('br'), _vm._v("\n                                 Administrator. The owner can authorize any member to become the administrator of the team."), _c('br'), _vm._v("\n                                Change ownership. The owner can transfer ownership to any member and be relegated to administrator. "), _c('br'), _vm._v("\n                                Dismiss team. Only the creator of the group is able to dismiss the group. This action is irreversible and all the members will be removed from the group. "), _c('br'), _vm._v("\n                                Dismiss sub-team. The creator and administrators are able to dismiss the sub-teams. All the members from the dismissed sub-teams are still categorized in the team.")])]), _vm._v(" "), _c('div', {
    staticClass: "aboutus",
    attrs: {
      "id": "signUp"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Sign up")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("Anyone with a valid email address is able to register a Crait account. Please read Crait Service Terms and Privacy Policy before registration. ")])]), _vm._v(" "), _c('div', {
    staticClass: "aboutus",
    attrs: {
      "id": "forgotPassword"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Forgot Password")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("Please click ‘Forgot Password’ button below and submit your email address which registered for Crait. You will get an email to reset your password. ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-abedd5a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Serversupport.vue
// module id = 302
// module chunks = 1